import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { CarrierAnnounce } from '@/components/arrivals/CarrierAnnounce';
import { carrierFromToken, readAnnouncements, applyAnnouncements } from '@/lib/announcements';
import { initialLoadings } from '@/data/arrivalsData';

// Public page behind the carrier's link (no login). Mobile first.
export default function Avizace() {
  const { token } = useParams();
  const carrier = carrierFromToken(token);
  const loadings = useMemo(() => applyAnnouncements(initialLoadings, readAnnouncements()), []);

  return (
    <div className="min-h-screen bg-slate-50 px-4 py-6">
      <div className="mx-auto max-w-md">
        {carrier ? <CarrierAnnounce carrier={carrier} loadings={loadings} /> : <div className="text-sm">404</div>}
      </div>
    </div>
  );
}
